<template>
    <Head title="Complete seu cadastro" />
    <Heading
        title="Complete seu cadastro"
        class="px-4 xl:px-[15.5vw] pt-18 sm:pt-32"
    />
    <form @submit.prevent="submitForm" class="pt-10 pb-14 px-4 xl:px-[16vw]">
        <div class="max-w-[873px]">
            <section class="pt-10">
                <h2 class="text-3xl font-semibold text-primary text-left">
                    Meus Dados
                </h2>
                <section class="pt-10">
                    <p class="text-xl">Complete seu cadastro antes de prosseguir.</p>
                    <p class="mt-11"><span class="text-red-600">* </span>Campos obrigatórios</p>
                </section>

                <div class="mt-3">
                    <label class="flex font-bold">Apelido</label>
                    <span class="text-[14px] text-darkgrey"
                        >Como você gostaria de ser chamado?</span
                    >
                    <Input
                        placeholder="Preecha aqui o seu apelido.."
                        ref="nickname"
                        type="text"
                        maxlength="40"
                        class="mt-2"
                        id="nickname"
                        v-model="this.form.nickname"
                    />
                </div>
                <div class="mt-3">
                    <label for="name" class="flex font-bold">Nome<span class="text-red-600">* </span></label>
                    <Input
                        required
                        name="name"
                        placeholder="João"
                        maxlength="70"
                        type="text"
                        v-model="this.form.name"
                    />
                    <label class="flex font-bold mt-3"> CPF </label>
                    <span class="font-bold"
                        >Seu CPF cadastrado é o
                        <strong>{{
                            formatarCpf(profile.cpf)
                        }}</strong></span
                    >

                    <label class="flex font-bold mt-3"
                        >Data de Nascimento</label
                    >
                    <Input
                        class="max-w-[150px]"
                        name="dob"
                        placeholder="DD/MM/AAAA"
                        maxlength="10"
                        @keyup="formatDate"
                        type="text"
                        v-model="form.dob"
                    />
                </div>
            </section>

            <section class="pt-10">
                <h2 class="text-3xl font-semibold text-left">
                    Contato
                </h2>

                <label class="flex font-bold mt-3">Email<span class="text-red-600">* </span></label>
                <Input
                    required
                    name="email"
                    placeholder="Exemplo: joao@email.com"
                    type="email"
                    v-model="form.email"
                    :state="state"
                    disabled
                />


                <label for="phoneNumber" class="flex font-bold mt-3"
                    >Celular<span class="text-red-600">* </span>
                </label>
                <Input
                    required
                    name="phoneNumber"
                    placeholder="(00) 00000-0000"
                    type="text"
                    @keypress="formatPhoneNumber"
                    v-model="form.mobile"
                />

            </section>

            <section class="pt-10">
                <h2 class="text-3xl font-semibold text-primary text-left">
                    Endereço
                </h2>
                <div class="mt-3">
                    <div class="flex flex-col">
                        <label class="flex font-bold mt-3">CEP<span class="text-red-600">* </span></label>
                        <Input
                            required
                            placeholder="00000-000"
                            type="text"
                            maxlength="9"
                            @keypress="formatPostalCode"
                            @input="getAdress"
                            v-model="this.form.address.zipCode"
                        />
                        <a
                            class="text-indigo-500"
                            target="_blank"
                            href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                            >Não sei meu CEP</a
                        >
                    </div>

                    <label for="adress" class="flex font-bold mt-3">
                        Endereço<span class="text-red-600">* </span>
                    </label>
                    <Input
                        required
                        name="adress"
                        placeholder="Rua das Flores"
                        type="text"
                        v-model="this.form.address.address"
                    />

                    <label class="flex font-bold mt-3"> Número <span class="text-red-600">* </span></label>
                    <Input
                        required
                        placeholder="123"
                        type="text"
                        @keypress="onlyNumbers"
                        v-model="this.form.address.number"
                    />

                    <label for="complement" class="flex font-bold mt-3">
                        Complemento
                    </label>
                    <Input
                        name="complement"
                        placeholder="Casa, Apartamento, Quadra..."
                        type="text"
                        v-model="this.form.address.complement"
                    />

                    <label for="district" class="flex font-bold mt-3">
                        Bairro<span class="text-red-600">* </span>
                    </label>
                    <Input
                        required
                        name="district"
                        placeholder="São José"
                        type="text"
                        v-model="this.form.address.district"
                    />

                    <label class="flex font-bold mt-3">Cidade<span class="text-red-600">* </span></label>
                    <Input
                        required
                        name="city"
                        placeholder="São José"
                        type="text"
                        v-model="this.form.address.city"
                    />

                    <label class="flex font-bold mt-3">Estado<span class="text-red-600">* </span></label>
                    <Select
                        placeholder="Selecione um estado"
                        :options="states"
                        class="!w-full border-2"
                        v-model="this.form.address.state"
                    />
                </div>
            </section>
            <p
                v-for="(error, key) in errors"
                :key="key"
                class="text-red-600 mt-4"
            >
                {{ error }}
            </p>
            <p class="text-red-600 mt-4">{{ $page.props.flash.error }}</p>
            <Button class="mt-12">
                Salvar
            </Button>
        </div>
    </form>
    <transition>
        <div
            v-if="$page.props.flash.success"
            class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
        >
            <div
                class="bg-white border-[1px] border-primary rounded-[4px] w-2.5/12 px-4 py-4 leading-9"
            >
                <button
                    class="float-right"
                    @click="next"
                >
                    <Icon name="Fechar" />
                </button>
                <h1 class="text-[20px] font-bold text-primary">Sucesso</h1>
                <p class="text-[16px] leading-6">
                    {{ $page.props.flash.success.description }}
                </p>
                <Button @click="next" class="max-w-[200px] mt-8 mx-auto">
                    Prosseguir
                </Button>
            </div>
        </div>
    </transition>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import { Head } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Input from "@/Components/UI/Form/InputWithoutIcon.vue";
import Select from "@/Components/UI/Form/Select.vue";
import Autocomplete from "@/Components/Autocomplete.vue";
import Button from "@/Components/Button";

import {
    formatPhoneNumber,
    formatLandLine,
    onlyNumbers,
    formatPostalCode,
    formatCpf,
    formatDate,
} from "@/Helpers/masks";
import axios from "axios";

export default {
    components: {
        AuthenticatedLayout,
        Head,
        Heading,
        Icon,
        Input,
        Select,
        Autocomplete,
        Button,
    },
    props: {
        profile: Object,
        address: Object,
        updateMessage: String,
        email: String,
    },
    data() {
        return {
            errors: [],
            data: this.profile,
            form: this.$inertia.form({
                id: this.profile.id,
                name: this.profile.name,
                nickname: this.profile.nickname,
                cpf: this.profile.cpf,
                dob: this.formatarData(this.profile.dob),
                email: this.email,
                email2: this.profile.email2,
                mobile: this.profile.mobile,
                mobile2: this.profile.mobile2,
                address: {
                    id: this.address?.id,
                    zipCode: this.address?.zipCode,
                    address: this.address?.address,
                    number: this.address?.number,
                    complement: this.address?.complement,
                    district: this.address?.district,
                    city: this.address?.city,
                    state: this.address?.state,
                },
            }),
            states: [
                "AC",
                "AL",
                "AP",
                "AM",
                "BA",
                "CE",
                "DF",
                "ES",
                "GO",
                "MA",
                "MS",
                "MT",
                "MG",
                "PA",
                "PB",
                "PR",
                "PE",
                "PI",
                "RJ",
                "RN",
                "RS",
                "RO",
                "RR",
                "SC",
                "SP",
                "SE",
                "TO",
            ],
        };
    },
    methods: {
        submitForm() {
            this.form.post(route("my-profile-store"), {
                preserveScroll: true,
            });
        },
        hideCpf(cpf) {
            cpf = cpf.replace(/(\d{3})/, "***");
            cpf = cpf.replace(/(\d{3})/, "***");
            return cpf;
        },
        formatarCpf(cpf) {
            if (cpf) {
                let cpf1 = cpf?.substring(0, 3);
                let cpf2 = cpf?.substring(3, 6);
                let cpf3 = cpf?.substring(6, 9);
                let cpf4 = cpf?.substring(9, 11);

                return "***." + "***." + cpf3 + "-" + cpf4;
            }
        },
        getAdress() {
            if (this.form.address.zipCode.length === 9) {
                const zipCodeFormat = this.form.address.zipCode.replace(
                    "-",
                    ""
                );

                axios
                    .get(`https://viacep.com.br/ws/${zipCodeFormat}/json/`)
                    .then((res) => {
                        this.form.address.address = res.data.logradouro;
                        this.form.address.complement = res.data.complemento;
                        this.form.address.district = res.data.bairro;
                        this.form.address.city = res.data.localidade;
                        this.form.address.state = res.data.uf;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        formatarData(data) {
            return data?.substring(0, 10).split("-").reverse().join("/");
        },
        next() {
            this.$page.props.flash.success = null;
            this.$inertia.get(route('dashboard'));
        },
        formatPhoneNumber,
        formatLandLine,
        onlyNumbers,
        formatPostalCode,
        formatCpf,
        formatDate,
    },
};
</script>
